import { INTERNAL_PATH_QUERY_PARAMETER } from './configs';

export const buildPath = (pathname: string, search: string): string => `${pathname}${search}`;

export const buildFullUrl = (path: string): string => {
  const url = new URL(window.xprops.parentUrl);
  url.searchParams.set(INTERNAL_PATH_QUERY_PARAMETER, path);

  return url.href;
};

